import ky from 'ky';
import { get } from "svelte/store";
import { variables } from '../env';
import type { APIErrorModel } from '$lib/models/APIErrorModel';
import { userAccountStore } from '$lib/stores/auth-store';
import { toast } from '$lib/components/organisms/toast/toast';

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);


const api = ky.extend({
    prefixUrl: variables.api_baseurl,
    timeout: false,
    retry: {
        limit: 0
    },
    credentials: 'include',
    hooks: {
        beforeRequest: [
            request => {
                if (request.url.includes('Account/Me')){
                    // Skip authentication check for the "Me" endpoint
                }
                else if (!(get(userAccountStore)?.id)) {
                    // If no user is logged in, redirect to login page
                    window.location.href = `${variables.api_baseurl}/account/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;
                    throw new Error('User not authenticated. Request aborted and redirected to login.');
                }

            },
            request => {
                if (SAFE_METHODS.has(request.method.toUpperCase())) return;
                const csrf = get(userAccountStore).csrf;
                if (!csrf) {
                    throw new Error('CSRF token missing. Account/Me must succeed before any state-changing request.');
                }
                request.headers.set(csrf.headerName, csrf.token);
            }
        ],
        beforeError: [
            async (error) => {
                // Added because some HTTPerrors are displayed directly in a toast and not specifically readable by the user. 
                const {response} = error;
                if(response.status === 404) {

                    const instanceOfAPIError = (err: any): err is APIErrorModel => {
                        return 'errorDescription' in err && 'requestId' in err && 'errorDetails' in err;
                    }

                    const responseData = await response.json();
                    if(instanceOfAPIError(responseData)){
                        if(responseData.errorDetails.length) error.message = responseData.errorDetails.join(". ");
                        
                    } 
                    return error;

                } else{
                    return error;
                }
            }
        ],
        afterResponse: [
            async (request, options, response) => {
                if (response.status === 401 || response.status === 302) {
                    window.location.href = `${variables.api_baseurl}/account/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;
                    userAccountStore.set({});
                }

                // Forbidden (user is authenticated, but the resource requires elevated permissions)
                if (response.status === 403) {
                    toast({
                        type: 'error',
                        title: 'Manglende tilgang',
                        description: 'Din bruker har ikke tilgang til å se denne informasjonen.'
                    })
                }

                if (response.status === 503) {
                    toast({
                        type: 'error',
                        title: 'Tjenesten er utilgjengelig',
                        description: 'En nettverks- eller server-feil oppstod. Vennlist vent litt og prøv å utføre operasjonen på nytt.'
                    })
                }
            }
        ]
    }
});

export default api;